import React from "react";
import { Link } from "@quintype/components";
import { string } from "prop-types";

import { SvgIconHandler } from "../SvgIconHandler";
import { LOGO_BASE_SIZE } from "../../../constants";

import "./AppLogo.m.css";

const AppLogo = ({ customStyle }) => {
  const { dimensions } = LOGO_BASE_SIZE;

  return (
    <Link href="/" styleName="logo-link" disableAjaxLinks={true}>
      <span styleName={customStyle || ""}>Logo</span>
      {/* <SvgIconHandler
        type="logo"
        width={dimensions.width}
        height={dimensions.height}
        viewBox={`0 0 ${dimensions.width} ${dimensions.height}`}
        className="app-logo"
        styleName={customStyle}
      /> */}
    </Link>
  );
};

AppLogo.propTypes = {
  customStyle: string,
};

AppLogo.defaultProps = {
  customStyle: "",
};

export default AppLogo;
